import { Link } from 'react-router-dom';

const variants = {
  primary: 'bg-gradient-to-r from-accent-500 to-accent-600 hover:from-accent-600 hover:to-accent-700 text-white shadow-lg shadow-accent-500/25 hover:shadow-xl hover:shadow-accent-500/30',
  secondary: 'bg-primary-700 hover:bg-primary-600 dark:bg-primary-600 dark:hover:bg-primary-500 text-white',
  outline: 'border-2 border-primary-600 dark:border-primary-500 text-primary-700 dark:text-primary-400 hover:bg-primary-700 hover:border-primary-700 hover:text-white dark:hover:bg-primary-600 dark:hover:border-primary-600',
  ghost: 'text-primary-700 dark:text-primary-400 hover:bg-primary-100 dark:hover:bg-primary-800/50',
  white: 'bg-white text-primary-700 hover:bg-cream-100 shadow-lg',
  wine: 'bg-gradient-to-r from-wine-700 to-wine-800 hover:from-wine-800 hover:to-wine-900 text-white shadow-lg shadow-wine-700/25'
};

const sizes = {
  sm: 'px-4 py-2.5 text-sm min-h-[44px]',
  md: 'px-6 py-3 text-base min-h-[48px]',
  lg: 'px-8 py-4 text-lg min-h-[52px]'
};

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  to,
  href,
  className = '',
  disabled = false,
  ...props
}) {
  const baseClasses = `
    inline-flex items-center justify-center gap-2
    font-semibold rounded-lg
    transition-all duration-200
    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent-500
    disabled:opacity-50 disabled:cursor-not-allowed
    ${variants[variant]}
    ${sizes[size]}
    ${className}
  `;

  if (to) {
    return (
      <Link to={to} className={baseClasses} {...props}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={baseClasses} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button className={baseClasses} disabled={disabled} {...props}>
      {children}
    </button>
  );
}
